import { Component, input } from '@angular/core';

import { LandingText } from '../landing.types';
import { LandingGlow } from './landing-glow.component';
import { RevealOnScrollDirective } from './reveal-on-scroll.directive';

@Component({
    selector: 'app-landing-security',
    standalone: true,
    imports: [LandingGlow, RevealOnScrollDirective],
    templateUrl: './landing-security.component.html',
    styleUrl: './landing-security.component.scss'
})
export class LandingSecurity {
    readonly text = input.required<LandingText>();

    // One icon per item, matching the order of securityItems.
    readonly securityIcons = ['pi-verified', 'pi-sync', 'pi-users', 'pi-eye'];
}
